/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_Dynamicssales1Inputs */



/**
* | output |
* | --- |
* | "Dynamics 365 Sales" |
*
* @param {Spaces_Provider_Dynamicssales1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_provider_dynamicssales1 = /** @type {((inputs?: Spaces_Provider_Dynamicssales1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_Dynamicssales1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dynamics 365 Sales")
	return /** @type {LocalizedString} */ ("Dynamics 365 Sales")
});
export { spaces_provider_dynamicssales1 as "spaces_provider_dynamicsSales" }